module.exports = __webpack_public_path__ + "img/20190727140552QQ截图20190727022934.1a11a4a0.png";